import { useEffect } from 'react';
import { sendScreenEvent } from '@useblu/blu-lytics';
import { useNavigate, useParams } from 'react-router-dom';

import { getPaymentLinkById } from '@/services/api';

const useRedirect = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const handleGetLinkData = async () => {
    await getPaymentLinkById(id).then(response => {
      const data = response.data.data;

      const paymentStatus =
        data?.last_payment_link_intent?.payment_link_transaction?.status;

      const paymentFailed =
        data.status === 'created' && paymentStatus === 'failed';
      const paymentFinish =
        data.status === 'paid' && paymentStatus === 'confirmed';
      const paymentExpired = data.status === 'expired';

      if (paymentFailed || paymentFinish || paymentExpired) {
        navigate(`/success/${id}`);
      }
    });
  };

  useEffect(() => {
    sendScreenEvent('link_blu_checkout_owner_payment_view');
  }, []);

  useEffect(() => {
    handleGetLinkData();

    const interval = setInterval(() => {
      handleGetLinkData();
    }, 5000);

    return () => clearInterval(interval);
  }, []);
};

export default useRedirect;
